var map = {
	"./Carousel/1.jpg": 724,
	"./Carousel/2.jpg": 725,
	"./Carousel/3.jpg": 726,
	"./avtar/11.jpg": 727,
	"./avtar/16.jpg": 728,
	"./avtar/3.jpg": 729,
	"./banner/1.jpg": 730,
	"./banner/2.jpg": 731,
	"./banner/3.jpg": 732,
	"./bcci_logo.png": 733,
	"./big-lightgallry/01.jpg": 734,
	"./big-lightgallry/011.jpg": 735,
	"./big-lightgallry/012.jpg": 736,
	"./big-lightgallry/013.jpg": 737,
	"./big-lightgallry/014.jpg": 738,
	"./big-lightgallry/015.jpg": 739,
	"./big-lightgallry/016.jpg": 740,
	"./big-lightgallry/02.jpg": 741,
	"./big-lightgallry/03.jpg": 742,
	"./big-lightgallry/04.jpg": 743,
	"./big-lightgallry/05.jpg": 744,
	"./big-lightgallry/06.jpg": 745,
	"./big-lightgallry/07.jpg": 746,
	"./big-lightgallry/08.jpg": 747,
	"./blog/12.png": 748,
	"./blog/14.png": 749,
	"./blog/4.jpg": 750,
	"./blog/9.jpg": 751,
	"./blog/blog-2.jpg": 752,
	"./blog/blog-3.jpg": 753,
	"./blog/blog-4.jpg": 754,
	"./blog/blog-5.jpg": 755,
	"./blog/blog-5.png": 756,
	"./blog/blog-6.jpg": 757,
	"./blog/blog-6.png": 758,
	"./blog/blog-single.jpg": 759,
	"./blog/blog.jpg": 760,
	"./blog/comment.jpg": 761,
	"./blog/img.png": 762,
	"./cloud.png": 763,
	"./color-picker.png": 764,
	"./cursor.png": 765,
	"./customize.png": 766,
	"./dashboard-ecommerce/1.png": 767,
	"./dashboard-ecommerce/2.png": 768,
	"./dashboard-ecommerce/3.png": 769,
	"./dashboard-ecommerce/4.png": 770,
	"./dashboard-ecommerce/watch.png": 771,
	"./dashboard/bg.jpg": 772,
	"./dashboard/bookmark.png": 773,
	"./dashboard/chat.png": 774,
	"./dashboard/clipboard.png": 775,
	"./dashboard/greeting.png": 776,
	"./dashboard/like.png": 777,
	"./dashboard/mobile.png": 778,
	"./dashboard/music.png": 779,
	"./dashboard/notification.png": 780,
	"./dashboard/pc.png": 781,
	"./dashboard/popup.png": 782,
	"./dashboard/profile-1.png": 783,
	"./dashboard/profile.png": 107,
	"./dashboard/profile_sm.png": 784,
	"./dashboard/recent-user-1.png": 785,
	"./dashboard/recent-user-2.png": 786,
	"./dashboard/recent-user-3.png": 787,
	"./dashboard/recent-user-4.png": 788,
	"./dashboard/tab.png": 789,
	"./dashboard/user.png": 790,
	"./dashboard/wallet.png": 791,
	"./dashboard/weather-image.png": 792,
	"./dashboard/whather_bg.jpg": 793,
	"./dashboard/whether.png": 794,
	"./ecommerce/01.jpg": 795,
	"./ecommerce/02.jpg": 796,
	"./ecommerce/03.jpg": 797,
	"./ecommerce/04.jpg": 798,
	"./ecommerce/05.jpg": 799,
	"./ecommerce/06.jpg": 800,
	"./ecommerce/07.jpg": 801,
	"./ecommerce/08.jpg": 802,
	"./ecommerce/09.jpg": 803,
	"./ecommerce/10.jpg": 804,
	"./ecommerce/11.jpg": 805,
	"./ecommerce/12.jpg": 806,
	"./ecommerce/card.png": 807,
	"./ecommerce/mastercard.png": 808,
	"./ecommerce/paypal.png": 809,
	"./ecommerce/product-table-1.png": 810,
	"./ecommerce/product-table-2.png": 811,
	"./ecommerce/product-table-3.png": 812,
	"./ecommerce/product-table-4.png": 813,
	"./ecommerce/product-table-5.png": 814,
	"./ecommerce/product-table-6.png": 815,
	"./ecommerce/visa.png": 816,
	"./email/1.jpg": 817,
	"./email/2.jpg": 818,
	"./email/3.jpg": 819,
	"./faq/1.jpg": 820,
	"./faq/2.jpg": 821,
	"./faq/3.jpg": 822,
	"./faq/4.jpg": 823,
	"./faq/learning-1.png": 824,
	"./job-search/1.jpg": 825,
	"./job-search/2.jpg": 826,
	"./job-search/3.jpg": 827,
	"./job-search/4.jpg": 828,
	"./job-search/5.jpg": 829,
	"./job-search/6.jpg": 830,
	"./lightgallry/01.jpg": 831,
	"./lightgallry/010.jpg": 832,
	"./lightgallry/011.jpg": 833,
	"./lightgallry/012.jpg": 834,
	"./lightgallry/013.jpg": 835,
	"./lightgallry/014.jpg": 836,
	"./lightgallry/015.jpg": 837,
	"./lightgallry/016.jpg": 838,
	"./lightgallry/02.jpg": 839,
	"./lightgallry/03.jpg": 840,
	"./lightgallry/04.jpg": 841,
	"./lightgallry/05.jpg": 842,
	"./lightgallry/06.jpg": 843,
	"./lightgallry/07.jpg": 844,
	"./lightgallry/08.jpg": 845,
	"./lightgallry/09.jpg": 846,
	"./logo/PLT-Logo.png": 196,
	"./logo/Vantr-v.png": 847,
	"./logo/Vanuatu_Logo.png": 422,
	"./logo/logo-1.png": 848,
	"./logo/logo-2.png": 849,
	"./logo/logo.png": 850,
	"./masonry/1.jpg": 851,
	"./masonry/10.jpg": 852,
	"./masonry/11.jpg": 853,
	"./masonry/12.jpg": 854,
	"./masonry/13.jpg": 855,
	"./masonry/14.jpg": 856,
	"./masonry/15.jpg": 857,
	"./masonry/2.jpg": 858,
	"./masonry/3.jpg": 859,
	"./masonry/4.jpg": 860,
	"./masonry/5.jpg": 861,
	"./masonry/7.jpg": 862,
	"./masonry/8.jpg": 863,
	"./masonry/9.jpg": 864,
	"./other-images/auth-bg-1.jpg": 865,
	"./other-images/bg-profile.png": 866,
	"./other-images/coming-soon-bg.jpg": 867,
	"./other-images/login-bg-2.jpg": 868,
	"./other-images/login-bg.jpg": 869,
	"./other-images/maintenance-bg.jpg": 870,
	"./other-images/mobile-clock-wallpaper.jpg": 871,
	"./other-images/paypal.png": 872,
	"./other-images/profile-style-img.png": 873,
	"./other-images/profile-style-img2.png": 874,
	"./other-images/profile-style-img3.png": 875,
	"./other-images/sad.png": 876,
	"./product/1.png": 877,
	"./product/10.png": 878,
	"./product/11.png": 879,
	"./product/12.png": 880,
	"./product/13.png": 881,
	"./product/14.png": 882,
	"./product/15.png": 883,
	"./product/2.png": 884,
	"./product/3.png": 885,
	"./product/4.png": 886,
	"./search-not-found.png": 887,
	"./sidebar-image/1.jpg": 888,
	"./sidebar-image/2.jpg": 889,
	"./sidebar-image/3.jpg": 890,
	"./sidebar-image/4.jpg": 891,
	"./sidebar-image/5.jpg": 892,
	"./sidebar-image/6.jpg": 893,
	"./sidebar-pattern/1.png": 894,
	"./sidebar-pattern/2.png": 895,
	"./sidebar-pattern/3.png": 896,
	"./sidebar-pattern/4.png": 897,
	"./sidebar-pattern/5.png": 898,
	"./sidebar-pattern/6.png": 899,
	"./smiley.png": 900,
	"./social-app/post-1.png": 901,
	"./social-app/post-2.png": 902,
	"./social-app/post-3.png": 903,
	"./social-app/post-4.png": 904,
	"./social-app/post-5.png": 905,
	"./social-app/post-6.png": 906,
	"./social-app/post-7.png": 907,
	"./social-app/post-8.png": 908,
	"./social-app/post-9.png": 909,
	"./social-app/social-image.png": 910,
	"./social-app/timeline-1.png": 911,
	"./social-app/timeline-2.png": 912,
	"./social-app/timeline-3.png": 913,
	"./social-app/timeline-4.png": 914,
	"./start-conversion.jpg": 915,
	"./user-card/1.jpg": 916,
	"./user-card/2.jpg": 917,
	"./user-card/3.jpg": 918,
	"./user-card/5.jpg": 919,
	"./user-card/6.jpg": 920,
	"./user-card/7.jpg": 921,
	"./user/1.jpg": 922,
	"./user/10.jpg": 923,
	"./user/11.jpg": 924,
	"./user/11.png": 925,
	"./user/110.jpg": 926,
	"./user/12.jpg": 927,
	"./user/120.jpg": 928,
	"./user/14.jpg": 929,
	"./user/15.jpg": 930,
	"./user/15.png": 931,
	"./user/16.jpg": 932,
	"./user/16.png": 933,
	"./user/2.jpg": 934,
	"./user/2.png": 935,
	"./user/22.jpg": 936,
	"./user/3.jpg": 937,
	"./user/3.png": 938,
	"./user/33.jpg": 939,
	"./user/4.jpg": 940,
	"./user/5.jpg": 941,
	"./user/6.jpg": 942,
	"./user/7.jpg": 943,
	"./user/8.jpg": 944,
	"./user/9.jpg": 945,
	"./user/user.jpg": 946,
	"./user/user.png": 947
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 723;